<template>
  <div class="content">
    <h1>孩子王育儿顾问</h1>
    <div class="cell">
      <img src="@/assets/images/avatar_ys.png" />
      <div>
        <p>亲爱的会员，有什么问题都可以问我哦～</p>
        <span v-if="equity">{{ equity }}</span>
      </div>
    </div>
    <textarea
      v-model="res"
      class="rs-form--content"
      placeholder="请描述您的问题："
    />
    <div class="btn">
      <p @click="go" ref="btn">立即咨询</p>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: {
    content: {
      type: String,
      default: ''
    },
    equity: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      res: this.content
    }
  },
  mounted() {},
  methods: {
    go() {
      if (this.res.length <= 8) {
        Toast('输入字符需要大于8个字符')
        return
      }
      this.$refs.btn && this.$refs.btn.focus()
      if (!this.$$isHZWApp() && !this.$$isRkhy()) {
        window.location.href = `http://a.app.qq.com/o/simple.jsp?pkgname=com.kidswant.ss&cmd=usercard&userid=${this.$$cookie(
          'uid'
        )}` //app下载页
        return
      }
      this.$$newTrackClick({
        bizType: '180',
        pageLevelId: '121012508',
        clickId: '200007',
        pageParam: {
          fuid: this.$$cookie('uid')
        },
        positionParam: {
          fuid: this.$$cookie('uid')
        }
      })
      setTimeout(() => {
        location.href =
          'https://api.cekid.com?cmd=imktalk&pageSource=0602&shopId=0000000002&targetId=0000000002&sendText=' +
          this.res
      }, 200)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin';
h1 {
  color: #121212;
  font-weight: 500;
  margin-top: rem(36px);
  margin-bottom: rem(36px);
  font-size: rem(32px);
  text-align: center;
}
.cell {
  display: flex;
  padding: 0 rem(30px);
  img {
    width: rem(74px);
    height: rem(74px);
  }
  div {
    padding: rem(20px) 0 rem(20px) rem(24px);
    width: rem(596px);
    border-radius: rem(2px) rem(28px) rem(28px) rem(28px);
    background: #ffffff;
    margin-left: rem(20px);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    p {
      color: #2c2c2c;
      font-size: rem(26px);
    }
    span {
      color: #fe3077;
      margin-top: rem(14px);
      font-size: rem(24px);
    }
  }
}
.rs-form--content {
  height: rem(236px);
  border: 0;
  width: rem(690px);
  margin-left: rem(30px);
  border-radius: rem(16px);
  color: #121212;
  resize: none;
  margin-top: rem(28px);
  padding: rem(20px) rem(24px);
  font-size: rem(28px);
}
.btn {
  background-color: white;
  overflow: hidden;
  margin-top: rem(30px);
  p {
    width: rem(686px);
    height: rem(80px);
    text-align: center;
    margin: rem(10px) 0 rem(10px) rem(32px);
    line-height: rem(80px);
    border-radius: rem(40px);
    background: linear-gradient(90deg, #ff397e 0%, #ff074c 100%);
    color: #ffffff;
    font-weight: 500;
    font-size: rem(30px);
  }
}
</style>
